module.exports = __webpack_public_path__ + "img/tips-clock.475585cb.svg";